import React, { useState, useEffect, useRef } from "react"
import {useLoaderData, useParams} from "react-router-dom"
import api from "../../api/axiosConfig";
import './Approval.css'
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';
import { useForm } from 'react-hook-form';

import emailjs from '@emailjs/browser';

export default function Approval() {
  const FormData = require('form-data')
  const formData = new FormData()

  const dateOpened = new Date();
  let approvedDate = dateOpened.toString();

  const { register, handleSubmit} = useForm();

  const {key, employeeEmail, month, year} = useParams();
  const timesheetDetails = useLoaderData()
  const timesheets = timesheetDetails.sheets
  const photos = timesheetDetails.photos
  const tok = timesheetDetails.token
  const bg = timesheetDetails.background

  var publicHolidays = timesheets.filter(x => x.dayType === 'Public Holiday');
  var totalHolidays = publicHolidays.length;

  var annualLeaves = timesheets.filter(x => x.dayType === 'Annual Leave');
  var totalLeaves = annualLeaves.length;
  
  var sickLeaves = timesheets.filter(x => x.dayType === 'Sick Leave');
  var totalSicks = sickLeaves.length;
  
  var approvedOvertime = timesheets.filter(x => x.hoursOvertime > 0);
  
  const allHoursWorked = timesheets.map(row => JSON.parse(row.hoursWorked));
  const allOvertimeHours = timesheets.map(row => JSON.parse(row.hoursOvertime));

  var totalHoursWorked = 0;
    for (let i = 0; i < allHoursWorked.length; i++ ) {
      totalHoursWorked += allHoursWorked[i];
    }

  var totalOvertimeHours = 0;
    for (let i = 0; i < allOvertimeHours.length; i++ ) {
      totalOvertimeHours += allOvertimeHours[i];
    }
  
  var file = null;

  var isToken = false;
  if(key===tok.key&& tok.response != "approved" && tok.response != "rejected"){
    isToken=true;
  }

  var isApproved = false;
  if(tok.response=="approved"){
    isApproved = true;
  }


  const getPDF = async() => {
    try{      
        const response = await api.get('/request/'+ employeeEmail + "/" + month + "/" + year);
        var linkSource = `data:application/pdf;base64,${response.data}`;
        const downloadLink = document.createElement("a");
        const fileName = employeeEmail.substring(0, employeeEmail.indexOf("@")).toUpperCase().replace(".", " ")+"-"+month+"-"+year;

        downloadLink.href = linkSource;
        downloadLink.download = fileName;
        downloadLink.click();

        }catch(err){
        console.log(err);
    }
}
  

const getEmployeeName = () => {
const tempName = employeeEmail.substring(0, employeeEmail.indexOf("@")).replace(".", " ");
const arr = tempName.split(" ")
for (var i = 0; i < arr.length; i++) {
    arr[i] = arr[i].charAt(0).toUpperCase() + arr[i].slice(1);
}
const employeeName = arr.join(" ");
return employeeName
}
  
  const time = new Date();
  time.setHours(8,  0);

  const hours = time.getHours();
  const minutes = ((time.getMinutes() < 10 ? '0': '')+time.getMinutes());
  const defaultTimeIN = `${hours}:${minutes}`;

  var timeIN = "";

  const setStartTime = (e) => {
    if(e>0){
    timeIN = defaultTimeIN;
    }else{
      timeIN = " "
    }
  }

  var timeOUT = "";

  const setStopTime = (e1, e2) => {
    if(e1>0){
    var exitHour = Number(e2) + Number(hours) + Number(9);
    timeOUT=`${exitHour}:${minutes}`;
    }else{
      timeOUT = " "
    }
  }

  

  let approverComments = ' ';
  const setRemarks = (e) => {
     approverComments = e.target.value
    console.log(approverComments)
  }
  

 let response = ' ';
  let message = ' ';
  let comments = ' ';
  const sendEmail = (comms) => {
    if(approverComments == ' '){
      approverComments = comms;
    }
    var templateParams = {
      employeeEmail: employeeEmail,
      month: month,
      year: year,
      response: response,
      name: tok.managerName,
      comments: approverComments,
      message: message,
      admin: 'kristine.furto@isphereiq.com'
    }
    console.log(templateParams)
    emailjs.send('service_hc4879t', 'template_sy5karg', templateParams, '_Nxdpscq-t21WlkV6')
      .then((result) => {
          console.log(templateParams)
          console.log(result.text);
          alert("Timesheet has been "+response+"!")
          window.location.reload();
      }, (error) => {
          console.log(error.text);
      });
  };

  const approveRequest = () =>{
  try{  
    const pdf = new jsPDF('p', 'mm', 'a4', true);
    const pdfWidth = pdf.internal.pageSize.getWidth();
    const pdfHeight = pdf.internal.pageSize.getHeight();

    html2canvas(document.getElementById("Page1")).then((canvas) => {
      const imgData = canvas.toDataURL('image/png');
      const imgWidth = canvas.width;
      const imgHeight = canvas.height;
      const ratio = Math.min(pdfWidth / imgWidth, pdfHeight / imgHeight);
      const imgY = 0;
      const imgX = 3;
      pdf.addImage(imgData, 'PNG', imgX, imgY, imgWidth * ratio - 3, imgHeight * ratio);
      html2canvas(document.getElementById("Page2")).then((canvas2) => {
        const imgWidth2 = canvas2.width;
        const imgHeight2 = canvas2.height;
        const ratio2 = Math.min(pdfWidth / imgWidth2, pdfHeight / imgHeight2);
        const imgX2 = 0;
        const imgY = 5;
        const imgData2 = canvas2.toDataURL('image/png');
        pdf.addPage();
        pdf.addImage(imgData2, 'PNG', imgX2, imgY, imgWidth2 * ratio2 - 4, imgHeight2 * ratio2 - 3);
        response = "approved";
        file = pdf.output('blob');
        console.log(file)
        formData.append('file', file)
        const res = api.post('/request/approve/' + key + "/" + response + "/" + employeeEmail + "/" + month + "/" + year, formData);
        console.log(res);
        response = "approved";
        message = `http://timesheet.isphereiq.com/approval/${key}/${employeeEmail}/${month}/${year}`
        comments = "Approved via Web App"
        sendEmail(comments);
      })
    }) 
  }catch(err){
    console.error(err)
    alert("Timesheet approval FAILED!");
  }

}

  const rejectRequest = () =>{
    try{
      response = "rejected";
      let reqData = new FormData();
      reqData.append('managerName', tok.managerName);
      reqData.append('managerEmail', tok.managerEmail);
      const res = api.post('/request/save/' + key + "/" + response + "/" + employeeEmail + "/" + month + "/" + year, reqData);
      comments = "Rejected by Web App"
      response = "rejected";
      message = `http://timesheet.isphereiq.com/approval/${key}/${employeeEmail}/${month}/${year}`
      sendEmail(comments)
    }catch(err){
      console.error(err)
    }
  }

  const pdfRef = useRef();
  


  return(
    <div className="approvalForm">
    <div id="Page1">
    <div className="requestHeader"> 
    <h1 className="requestMonthDisplay">{ month } { year }</h1>     
    <h6 className="requestSender">{ employeeEmail }</h6> 
    <div className="wrapper">
      <h6 className="requestSender2">Employee Name: {getEmployeeName()}</h6>
      <h6 className="requestSender2">Client: {bg.client}</h6>
      <h6 className="requestSender2">Project: {bg.project}</h6>
      <h6 className="requestSender2">Location: {bg.clientLocation}</h6>
    </div>
    {/* load client/location/project here */}
    </div>  
    <input type="hidden" className="form-control" name="employeeEmail" value={employeeEmail}/>
    <table className="approvalTbl">
      <thead>
        <tr className="approvalHdr">
          <th>DATE</th>
          <th>DAY TYPE</th>
          <th>HOURS WORKED</th>
          <th>OVERTIME HOURS</th>
          <th>TIME IN</th>
          <th>TIME OUT</th>
        </tr>
      </thead>
      <tbody className="approvalBody">
        {
          timesheets.map((user, index) => {
            return <tr key={index}>
              <td>{user.date}</td>
              <td>{user.dayType}</td>
              <td className="uHours">{user.hoursWorked}</td>
              <td className="uHours">{user.hoursOvertime}</td>
              <td onLoad={setStartTime(user.hoursWorked)}>{timeIN}</td>
              <td onLoad={setStopTime(user.hoursWorked, user.hoursOvertime)}>{timeOUT}</td>
            </tr>
          })
        }
      </tbody>
    </table>
    <table className="page1footer">
      <tr> 
        <th className="totalHours">TOTAL HOURS WORKED: {totalHoursWorked}</th>
      </tr>
    </table>
    <div className="wrapper">
    <table className="dtlSummaryTbl">
      {/* <tr className="totalHours">TOTAL OVERTIME HOURS: {totalOvertimeHours}</tr>   */}
      <thead> 
      <tr className="dtlSummaryHdr" >
        <th>SUMMARY</th>
        <th>DATES</th> 
        <th>No of Work Days</th>  
      </tr>
      </thead>
      
      <tbody className="dtlSummaryBody">
      <tr>
        <td className="summColumn1">Public Holiday</td>
        <td>
          <table  className="dtlSummaryDates">
            <tbody>
            {
              publicHolidays.map((user, index) => {
                return <tr key={index} className="day">
                  <td>{user.date}</td>
                </tr>
              })
            }
            </tbody> 
        </table>
      </td>
      <td>{totalHolidays}</td>
      </tr>
      </tbody>
      <tbody className="dtlSummaryBody">
      <tr>
        <td className="summColumn1">Annual Leave</td>
        <td className="dtlSummaryDates">
          <table>
            <tbody>
            {
              annualLeaves.map((user, index) => {
                return <tr key={index}>
                  <td>{user.date}</td>
                </tr>
              })
            }
            </tbody> 
        </table>
        </td>
        <td>{totalLeaves}</td>
      </tr>
      </tbody>
      <tbody className="dtlSummaryBody">
      <tr>
        <td className="summColumn1">Sick Leave</td>
        <td>
          <table>
            <tbody className="dtlSummaryDates">
            {
              sickLeaves.map((user, index) => {
                return <tr key={index}>
                  <td>{user.date}</td>
                </tr>
              })
            }
            </tbody> 
        </table>
      </td>
      <td>{totalSicks}</td>
      </tr>
      </tbody>
      <tbody className="dtlSummaryBody">
      <tr className="dtlSummaryHdr2" >
        <th></th>
        <th></th>
        <th>Total Hours</th>
      </tr>
      <tr>
        <td className="summColumn1">Approved Overtime</td>
        <td className="dtlSummaryDates">
          <table>
            <tbody>
            {
              approvedOvertime.map((user, index) => {
                return <tr key={index}>
                  <td>{user.date}</td>
                </tr>
              })
            }
            </tbody> 
        </table>
        </td>
        <td>{totalOvertimeHours}</td>
      </tr>
      </tbody>
    </table>
    <div className="approverWrapper">
      <h6 className="requestSender2">Approved By: {tok.managerName}</h6>
      <h6 className="requestSender2">Approver Email: {tok.managerEmail}</h6>
      <h6 className="requestSender2">Approval Date: {approvedDate}</h6>
      <h6 className="requestSender2" hidden={true}>Approver Comments: {approverComments}</h6>
    </div>
    </div> 
    </div>

    <div className="approvalPhotosContainer" id="Page2">
      {
        photos.map((index) =>    
          <div key={index}>          
          <img className='approvalPhotos' src={'data:image/png;base64,'+index} />
          </div>
        )
      }
    </div>
    
    {isToken &&
    <div> 
        <div className="approverDtls"> 
          <textarea className="remarksBox" {...register("approverComments", {required:true})} onChange={setRemarks} placeholder ="Enter Approver Remarks..."></textarea>
        </div>
        <div className="approvalFooter">
          <button type="button" className="rejectBtn" onClick={rejectRequest}>Reject</button>
          <button type="button" className="approveBtn" onClick={approveRequest}>Approve</button>
        </div>
      
    </div>}
    {isApproved &&
    <div> 
      <button className="downloadBTN" onClick={getPDF}>Download</button>
    </div>}
  </div>
  )
}

//loader func - loads api data before component renders
export const approvalDetailsLoader = async ({params}) => {
  const {key, employeeEmail, month, year} = params
  const[sheets, photos, token, background] = await Promise.all([
    api.get('/sheets/' + employeeEmail + "/" + month + "/" + year).then( res => res.data),
    api.get('/photos/' + employeeEmail + "/" + month + "/" + year).then( res => res.data.photoList),
    api.get('/request/' + key).then( res => res.data),
    api.get('/employee/'+ employeeEmail).then( res => res.data)
  ]);
  return{sheets, photos, token, background};
}

